import { useParticipantDetails } from "../../context/participantDetails";
import React from "react";
import { useMyExpAnalytics } from "apps/myExperience/context/analyticsWrapper";
import { AnalyticsEventNameEnum, AnalyticsScreenNameEnum } from "shared/enums/AnalyticsEnums";
import AnalyticsDatastoreType from "shared/enums/AnalyticsDatastoreType";

export default function useMyActionsService() {
  const { logEvent } = useMyExpAnalytics();
  const { participantDetails } = useParticipantDetails();
  const [randomKey, setRandomKey] = React.useState<number>(Date.now());

  const myActionsCount = React.useMemo(() => {
    let actionsCount = 0;
    actionsCount += participantDetails?.actions?.length ?? 0;
    actionsCount += participantDetails?.events?.[0]?.actions?.length ?? 0;
    participantDetails?.events?.[0]?.programs?.forEach(p => {
      actionsCount += p.actions?.length ?? 0;
    });
    return actionsCount;
  }, [participantDetails]);

  const actionClickCallback = React.useCallback(() => {
    setRandomKey(Date.now());
    logEvent(
      AnalyticsEventNameEnum.CLICK,
      {
        screenType: AnalyticsScreenNameEnum.MY_ACTIONS
      },
      AnalyticsDatastoreType.MIXPANEL_INTERNAL
    );
  }, [logEvent]);

  return {
    myActionsCount,
    actionClickCallback,
    randomKey
  };
}
